/**
 * @file The ids of the goals behind the Goal figure for the granted level: the
 * caller's user goal at `self`, one goal per team of theirs at `team` and the
 * Org goal at `org`, all through `analyticsGoalId`. Consumers: the Overview
 * panel and `useHomeGoalProgress`, which read the team goals together through
 * `analyticsTeamGoalRead`. A team level with no team has no goal id, which
 * reads as not found. Goals of different subjects are never combined.
 */
import { analyticsGoalId, type AnalyticsScopeLevel, type DocId } from '#types';

export const analyticsScopeGoalIds = (
  level: AnalyticsScopeLevel,
  uid: string,
  teams: readonly DocId[],
  periodStart: string,
): string[] => {
  if (level === 'self')
    return [analyticsGoalId({ subject: 'user', uid, teamId: null, periodStart })];
  if (level === 'team')
    return teams.map((teamId) =>
      analyticsGoalId({ subject: 'team', uid: null, teamId, periodStart }),
    );
  return [
    analyticsGoalId({ subject: 'org', uid: null, teamId: null, periodStart }),
  ];
};
